import script from "./GirdPostComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GirdPostComponent.vue?vue&type=script&setup=true&lang=js"

import "./GirdPostComponent.vue?vue&type=style&index=0&id=b6fa799e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6fa799e"]])

export default __exports__